
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M21.1667 10.5002H14.5V12.1668H20.3333V19.6668H3.66667V12.1668H5.33333V10.5002H2.83333C2.37333 10.5002 2 10.8727 2 11.3335V20.5002C2 20.961 2.37333 21.3335 2.83333 21.3335H21.1667C21.6267 21.3335 22 20.961 22 20.5002V11.3335C22 10.8727 21.6267 10.5002 21.1667 10.5002Z"></path><path d="M9.76329 13.7902C9.88579 13.7494 9.99746 13.6802 10.0891 13.5894L17.5891 6.08937C17.915 5.76354 17.915 5.23688 17.5891 4.91104L15.9225 3.24437C15.5966 2.91854 15.07 2.91854 14.7441 3.24437L7.24413 10.7444C7.15246 10.8352 7.08413 10.9469 7.04246 11.0702L6.16663 14.6669L9.76329 13.7902Z"></path><path d="M17.8333 16.3336H6.16663V18.0002H17.8333V16.3336Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiCustomFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
